module.exports = __webpack_public_path__ + "img/lg.fe4c6528.png";